import styled from '@emotion/styled';

export const DropdownWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const DropdownIcon = styled.span<{ open: boolean }>`
  font-size: 14px;
  margin-left: auto;
  transform: ${props => (props.open ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

export const StyledDropdown = styled.div`
  height: 44px;
  width: 100%;
  border-radius: 4px;
  border: 1px solid var(--border1);
  padding: 10px 16px;
  font-size: 16px;
  font-weight: 500;
  background: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    border: 1px solid var(--prim4);
  }
`;

export const DropdownContainer = styled.div`
  position: absolute;
  width: 100%;
  background: white;
  border: 1px solid var(--border1);
  border-radius: 4px;
  margin-top: 4px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  max-height: 300px;
  overflow-y: auto;
`;

export const DropdownList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const DropdownItem = styled.li`
  padding: 16px 24px;
  cursor: pointer;
  border-bottom: 1px solid var(--border1);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  &:hover {
    background: var(--neut7);
  }
`;

export const DropdownItemContent = styled.div`
  flex: 1;
`;

export const EditButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.7;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
    background: var(--border1);
  }

  &:focus {
    outline: none;
    opacity: 1;
    background: var(--border1);
  }
`;

export const CustomerDetails = styled.div`
  font-size: 14px;
  color: var(--neut3);
  line-height: 1.5;
`;

export const CreateButtonContainer = styled.div`
  padding: 16px 24px;
  border-bottom: 1px solid var(--border1);
  background: white;
  text-align: center;

  &:hover {
    background: var(--neut7);
  }
`;

export const PlusWrapper = styled.div`
  background-color: #f2f2f3;
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  max-width: 32px;
  max-height: 32px;
  border-radius: 8px;
  opacity: 0px;
  margin-right: 24px;
  color: var(--prim4);
`;

export const SelectedClientWrapper = styled.div`
  margin-top: 16px;
  display: flex;
  align-item: flex-start;
  justify-content: space-between;
  gap: 8px;
`;
